module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: false,
        isFullyHorizontal: true,
        resourceConnected: false,
        defaultView: 'stats',
    },

    model: {
        meta: {},
        view: null,
        fields: [
            {
                aliases: {
                    stats: {
                        name: 'fi fi-advertisement-stats',
                        type: 'symbol'
                    },
                    scheduler: {
                        name: 'fi fi-calendar',
                        type: 'symbol'
                    },
                    list: {
                        name: 'fi fi-advertisement-list',
                        type: 'symbol'
                    },
                },
                fieldCode: 'view',
                config: {
                    preventFieldLabel: true,
                },
                data: {
                    options: [
                        { name: ' ', value: 'stats' },
                        { name: ' ', value: 'scheduler' },
                        { name: ' ', value: 'list' },
                    ],
                },
                atom: {
                    code: 'CATEGORY_PICKER_TOGGLE_TEST',
                    renderType: 'toggle'
                },
            }
        ],
    },

    methods: {
        changeView(view){
            this.model.view = view
            this.closest('templates_core_controller_controller', controller => {
                controller.$.find(`> section.content > .templates_core_view_view`).hide()
                controller.$.find(`> section.content > .templates_core_view_view.view_${view}`).show()
            })

            if(view === 'list'){
                this.$.find(`> .cols > .col.center`).show()
            } else {
                this.$.find(`> .cols > .col.center`).hide()
            }
        }
    },

    hooks: {
        _postAttach($element, options){
            this.changeView(this.model.view)
        },

        onChildChanged($element, options){
            if(options.fieldCode === 'view'){
                this.changeView(options.value)
            }
        }
    }
}